import React, { useState } from "react";
import getHelpText from 'fantastic/lib/helpText';
import HelpItem from './items/HelpItem';


const Blocks = () => {
  const helpText = getHelpText();
  return (
    helpText.blocks.map((item, key) => {
      return <HelpItem key={key} item={item}/>
    })
  )
}

export default Blocks
